import { PayloadAction } from "@reduxjs/toolkit";
import { Page } from "../../../../common/models/Page";
import { GroupsState } from "../models/GroupsState";

const setPageGroups = (state: GroupsState, action: PayloadAction<Page>) => {
    state.page = action.payload.page;
}

export default setPageGroups;